import { gql } from '@apollo/client';
import { FileFragment } from 'graphql/File/fragments/FileFragment';
/**
 * @const ExportSaleItemOptionRelationsMutation
 * @since 1.0.0
 */
export const ExportSaleItemOptionRelationsMutation = gql `
  mutation ExportSaleItemOptionRelationsMutation($input: ExportSaleItemOptionRelationsInput!) {
    exportSaleItemOptionRelations(input: $input) {
      ...FileFragment
    }
  }

  ${FileFragment}
`;
